import { UNUSED_ENV_ID } from "constants/EnvironmentContants";

export const DEFAULT_ENV_ID = UNUSED_ENV_ID;

// function to get the default environment
export const getDefaultEnvId = () => {
  return DEFAULT_ENV_ID;
};
